import { render, staticRenderFns } from "./channel.vue?vue&type=template&id=4c0c64d0&scoped=true&"
import script from "./channel.vue?vue&type=script&lang=js&"
export * from "./channel.vue?vue&type=script&lang=js&"
import style0 from "./channel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./channel.vue?vue&type=style&index=1&id=4c0c64d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0c64d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a2\\Code_New\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c0c64d0')) {
      api.createRecord('4c0c64d0', component.options)
    } else {
      api.reload('4c0c64d0', component.options)
    }
    module.hot.accept("./channel.vue?vue&type=template&id=4c0c64d0&scoped=true&", function () {
      api.rerender('4c0c64d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/config/channel.vue"
export default component.exports